@if ($configSchema() != null) {
    <div class="form-group mt-4">
        <h5>Configurações do E-Docs</h5>
        <hr class="mt-0 mb-4" />
    </div>

    <div class="form-group mt-4 mb-2">
        <h6 class="d-inline-block">Forma de obtenção do processo</h6>
    </div>

    <!-- Forma de obtenção do processo -->
    <div featureHint="flowObjectDetails|AddToProcessOrigin" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right">
        <mat-radio-group class="process-origin mb-2" id="processOrigin" name="processOrigin" color="primary"
                         [ngModel]="$processOrigin()"
                         [required]="true"
                         (ngModelChange)="processOriginChange($event)"
        >
            <mat-radio-button [value]="ProcessOrigin.Instance">Processo autuado anteriormente na instância de Fluxo</mat-radio-button>
            <mat-radio-button [value]="ProcessOrigin.PublicAgentDeliberation">Processo obtido a partir de protocolo fornecido pelo usuário servidor</mat-radio-button>
            <mat-radio-button [value]="ProcessOrigin.Form">Processo obtido a partir de protocolo fornecido pelo usuário solicitante em um campo do formulário</mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- Sugestão de protocolo do processo -->
    @if ($processOrigin() == ProcessOrigin.PublicAgentDeliberation) {
        <div class="form-group ml-4 mt-3" featureHint="flowObjectDetails|AddToProcessProtocol">
            <label for="processProtocol">Sugestão de protocolo do processo</label>
            <input type="text" class="form-control" id="processProtocol" placeholder="XXXX-XXXXX" maxlength="10"
                   [class.is-invalid]="!$isProcessProtocolValid()"
                   [ngModel]="$processProtocol()"
                   (change)="onProcessProtocolChange($event.target.value)"
                   (input)="onProcessProtocolChange($event.target.value)"
            />
            @if (!$isProcessProtocolValid()) {
                <div class="invalid-feedback d-block mt-1">
                    Formato inválido.
                </div>
            }
        </div>
    }

    <!-- Campo do formulário contendo o protocolo -->
    @if ($processOrigin() == ProcessOrigin.Form) {
        <div class="form-group ml-4 mt-3" featureHint="flowObjectDetails|AddToProcessProtocolFormField">
            <label for="processProtocolFormField">Campo do formulário contendo o protocolo</label>

            <select class="form-control" id="processProtocolFormField" name="processProtocolFormField"
                    [ngModel]="$processProtocolFormField()"
                    (change)="onProcessProtocolFormFieldChange($event.target.value)"
            >
                @for (option of $processProtocolFormFieldOptions(); track option) {
                    <option [value]="option.value">{{option.description}}</option>
                }
            </select>
        </div>
    }

    <!-- Classificação Documental -->
    @if ($processOrigin() == ProcessOrigin.Form || $processOrigin() == ProcessOrigin.PublicAgentDeliberation) {
        <div class="content-type-text-row ml-4">
            <div class="form-group">
                <h6 featureHint="flowObjectDetails|AddToProcessCancellationDocumentClass" featureHintHAlign="right" featureHintVAlign="top">
                    <span>Classificação Documental para ocasiões de cancelamento do Fluxo</span>
                </h6>
            </div>

            <document-class [_model]="$cancellationDocumentClass()"
                            [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                            (_modelChange)="onUpdateCancellationDocumentClass($event)"
            ></document-class>
        </div>
    }

    <div class="form-group mt-4">
        <h6>Mensagem de Entranhamento</h6>
    </div>

    <!-- Mensagem de Entranhamento -->
    @if ($isAddToProcessSummaryBootstrapFinished()) {
        <div class="form-group ml-3px" featureHint="flowObjectDetails|AddToProcessSummary" featureHintHAlign="right" featureHintVAlign="top">
            <editor name="addToProcessSummary" apiKey="no-api-key"
                    [ngModel]="$addToProcessSummary()"
                    [init]="tinyMceOptionsProcess"
                    (ngModelChange)="$addToProcessSummary.set($event)"
            ></editor>
            <textarea id="tinyMceAddToProcess" class="d-none"></textarea>
        </div>
    }

    <div class="form-group mt-4">
        <h6>Nível de Acesso</h6>
    </div>

    <!-- Nível de Acesso -->
    <access-level #accessLevelRef
                  [_model]="$configSchemaSectionAccessLevel()"
                  [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                  [_isReadOnlyMode]="$isReadOnlyMode()"
                  (_modelChange)="onUpdateAccessLevel($event)"
    ></access-level>
}
